import ApiService from "../api.service";
import JwtService from "../jwt.service";

export const DADOS_AUTENTICACAO = "dadosAutenticacao";

const state = {
  usuario: {},
  menus: [],
  permissoes: [],
  funcoes: [],
  autenticado: !!JwtService.obterToken(),
};

const getters = {
  usuarioAutenticado(state) {
    return state.usuario;
  },

  menus(state) {
    return state.menus;
  },

  permissoes(state) {
    return state.permissoes;
  },

  funcoes(state) {
    return state.funcoes;
  },

  estaAutenticado(state) {
    return state.autenticado;
  },

  temFuncao(state) {
    return (funcao) => {
      return state.funcoes.includes(funcao);
    };
  },

  temPermissao(state) {
    return (permissao) => {
      return state.permissoes.includes(permissao);
    };
  },
};

const actions = {
  [DADOS_AUTENTICACAO](context, dados) {
    if (dados) {
      context.commit("setarDados", dados);
    } else {
      context.commit("removerDados");
    }
  },
};

const mutations = {
  setarDados(state, { usuario, token, menus, permissoes, funcoes }) {
    state.usuario = usuario;
    state.menus = menus;
    state.permissoes = permissoes;
    state.funcoes = funcoes;
    state.autenticado = !!token;
    JwtService.salvarToken(token);
    ApiService.setHeader();
  },

  removerDados(state) {
    state.usuario = {};
    state.menus = [];
    state.permissoes = [];
    state.funcoes = [];
    state.autenticado = false;
    JwtService.excluirToken();
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
